import { Injectable } from '@angular/core';
import { Languagei18n } from '../enums/languages';
import { Title } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {first, skip} from 'rxjs';
import moment from 'moment';
import { SUPPORTED_LANGUAGES } from '../constants/languages';
import {Translator} from "@livechat/shared";

export const LANGUAGE_KEY = 'language';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService implements Translator {
  constructor(
    private title: Title,
    private translateService: TranslateService
  ) {}

  //TODO: fill this property on service start (constructor)
  get selectedLanguage(): string | undefined {
    return this.retrieveLanguage();
  }

  get DATE_FORMAT_FULL(): string {
    return this.translateService.instant('DATE_PIPE_FORMAT_FULL');
  }

  get DATE_FORMAT_FULL_WITH_SECONDS(): string {
    return this.translateService.instant('DATE_PIPE_FORMAT_FULL_WITH_SECONDS');
  }

  get DATE_FORMAT_DATE_ONLY(): string {
    return this.translateService.instant('DATE_FORMAT_DATE_ONLY');
  }

  get DATE_MONTH_NAME_ONLY(): string {
    return this.translateService.instant('DATE_MONTH_NAME_ONLY');
  }

  public key(key: string | string[], params?: object) {
    return this.translateService.instant(key, params);
  }

  keyAsync(key: string | string[], params?: object) {
    return this.translateService.get(key, params);
  }
  

  private storeLanguage(language: Languagei18n | string) {
    localStorage.setItem(LANGUAGE_KEY, language);
  }

  public retrieveLanguage(): Languagei18n | undefined {
    let languageStr =
      this.getLanguageFromQueryParam() || localStorage.getItem(LANGUAGE_KEY) || undefined;
    if (!languageStr) {
      languageStr = Object.values(Languagei18n).find((lang) =>
        navigator.language.includes(lang)
      );
    }

    return languageStr as Languagei18n;
  }

  private getLanguageFromQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const language = urlParams.get('language');

    if (!language) {
      return;
    }

    const found = SUPPORTED_LANGUAGES.find((lang) =>
      language.toLowerCase().startsWith(lang)
    );

    if (found) {
      this.storeLanguage(found);
    }

    return found;
  }

  prepare() {
    const language = this.retrieveLanguage();

    if (language) {
      this.translateService.use(language)
        .pipe(first())
        .subscribe(() => this.title.setTitle(this.key('PAGE_TITLE')));
      moment.locale(language);
      
      this.translateService.onLangChange
        .pipe(skip(1))
        .subscribe((event: LangChangeEvent) => {
          this.storeLanguage(event.lang);
          location.reload();
      });
    } else {
      this.translateService.onLangChange
        .pipe(skip(1))
        .subscribe((event: LangChangeEvent) => {
          this.storeLanguage(event.lang);
          location.reload();
      });
    }

  }
}
